import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    userInfo: {},
    statusAudit: {},
    brandPushNews:{},//比对,的所有查询条件
    roleNews:{},//角色权限,的所有查询条件
  },
  mutations: {
    //比对,的所有查询条件
    brandpushinfo(state, val) {
      if(val[0]==-1){
        state.brandPushNews = {};
      }
      if(val[0]==0){
        state.brandPushNews.queryid = val[1];
      }
      if(val[0]==1){
        state.brandPushNews.id = val[1];
      }
      if(val[0]==2){
        state.brandPushNews.pageNo = val[1];
      }
      if(val[0]==3){
        state.brandPushNews.pageSize = val[1];
      }
      if(val[0]==5){//状态
        if(val[1]!=null){
          state.brandPushNews.WebsiteStatus = val[1];
        }
      }
      if(val[0]==6){
        state.brandPushNews.order = val[1];
      }
      if(val[0]==7){
        state.brandPushNews.createTimes = val[1];
      }
    },
    //角色权限,的所有查询条件
    roleInfo(state, val) {
      if(val[0]==-1){
        state.roleNews = {};
      }
      if(val[0]==0){
        state.roleNews.id = val[1];
      }
      if(val[0]==1){
        state.roleNews.pageNo = val[1];
      }
      if(val[0]==2){
        state.roleNews.pageSize = val[1];
      }
      if(val[0]==3){
        state.roleNews.order = val[1];
      }
      if(val[0]==4){
        state.roleNews.createTimes = val[1];
      }
    },
    getUserInfo(state, val) {
      state.userInfo = val;
      sessionStorage.setItem('userInfo', JSON.stringify(val));
    },
    setStatus(state, val) {
      state.statusAudit = val;
      localStorage.setItem('setStatusAudit', val);
    },
  },
  actions: {
    //比对-商标,的所有查询条件
    brandpushinfo(context, v) {
      context.commit('brandpushinfo', v);
    },
    //角色权限,的所有查询条件
    roleInfo(context, v) {
      context.commit('roleInfo', v);
    },
    getUserInfo(context, v) {
      context.commit('getUserInfo', v);
    },
    setStatusAudit(context, v) {
      context.commit('setStatus', v);
    },
  },
});



// WEBPACK FOOTER //
// ./src/store/store.js